import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdministrarUsuariosComponent } from '../modules/administracion/components/administrar-usuarios/administrar-usuarios.component';
import { AdministrarCatalogosComponent } from '../modules/catalogos/catalogos/components/administrar-catalogos/administrar-catalogos.component';
import { BusquedaObrasProcesoComponent } from '../modules/mapas/components/busqueda-obras-proceso/busqueda-obras-proceso.component';
import { InicioSesionComponent } from '../modules/login/components/inicio-sesion/inicio-sesion.component';
import { TableroComponent } from './components/tablero/tablero.component';
import { RegistroUsuarioComponent } from '../modules/login/components/registro-usuario/registro-usuario.component';
import { GeneracionObrasComponent } from '../modules/obras/components/generacion-obras/generacion-obras.component';
import { EdicionFichaTecnicaComponent } from '../modules/obras/components/edicion-ficha-tecnica/edicion-ficha-tecnica.component';
import { BusquedasFotosObraComponent } from '../modules/busquedas/components/busquedas-fotos-obra/busquedas-fotos-obra.component';
import { BusquedasAvanzadasComponent } from '../modules/busquedas/components/busquedas-avanzadas/busquedas-avanzadas.component';
import { FiltroFotosCapasComponent } from '../modules/busquedas/components/filtro-fotos-capas/filtro-fotos-capas.component';
import { EdicionIncidenciaObraComponent } from '../modules/obras/components/edicion-incidencia-obra/edicion-incidencia-obra.component';
import { BusquedaObrasPlaneacionComponent } from '../modules/mapas/components/busqueda-obras-planeacion/busqueda-obras-planeacion.component';
import { AdmonTramoLicitacionComponent } from '../modules/obras/components/admon-tramo-licitacion/admon-tramo-licitacion.component';
import { GeneradorIncidenciaObraComponent } from '../modules/obras/components/generador-incidencia-obra/generador-incidencia-obra.component';
import { ConsultarObrasComponent } from '../modules/obras/components/consultar-obras/consultar-obras.component';
import { GeneradorCarpetaComponent } from '../modules/carpeta-ejecutiva/components/generador-carpeta/generador-carpeta.component';
import { EdicionFichaPlaneacionComponent } from '../modules/obras/components/edicion-ficha-planeacion/edicion-ficha-planeacion.component';
import { TerminosYCondicionesComponent } from './components/terminos-y-condiciones/terminos-y-condiciones.component';
import { ListaDireccionesComponent } from './components/lista-direcciones/lista-direcciones.component';
import { ListaModulosPrincipalesComponent } from './components/lista-modulos-principales/lista-modulos-principales.component';
import { SeleccionModulosComponent } from './components/seleccion-modulos/seleccion-modulos.component';
import { LevantamientoObraComponent } from '../modules/administracion/components/levantamiento-obra/levantamiento-obra.component';
import { AprobacionLevatamientoObrasComponent } from '../modules/administracion/components/aprobacion-levatamiento-obras/aprobacion-levatamiento-obras.component';
import { LevantamientoAvanceComponent } from '../modules/administracion/components/levantamiento-avance/levantamiento-avance.component';
import { LarguilloComponent } from '../modules/obras/components/larguillo/larguillo.component';
import { AdministrarPerfilesComponent } from '../modules/administracion/components/administrar-perfiles/administrar-perfiles.component';
import { DetalleObraComponent } from '../modules/mapas/components/detalle-obra/detalle-obra.component';
import { CargaPresupuestosComponent } from '../modules/presupuestos/components/carga-presupuestos/carga-presupuestos.component';
import { SeleccionReportesComponent } from '../modules/presupuestos/components/seleccion-reportes/seleccion-reportes.component';
import { GraficaBarrasPrepEstadosComponent } from '../modules/presupuestos/components/grafica-barras-prep-estados/grafica-barras-prep-estados.component';
import { TableroPresupuestoComponent } from './components/tablero-presupuesto/tablero-presupuesto.component';
import { HomePresupuestosComponent } from '../modules/presupuestos/components/home-presupuestos/home-presupuestos.component';
import { ConsultarHistoricoObrasComponent } from '../modules/obras/components/consultar-historico-obras/consultar-historico-obras.component';
import { BuscadorArchivosObrasComponent } from '../modules/obras/components/buscador-archivos-obras/buscador-archivos-obras.component';
import { DashboardadminModule} from '../dashboardadmin/dashboardadmin.module';
import { ArchivosCarpetaEjecutivaComponent } from '../modules/administracion/components/archivos-carpeta-ejecutiva/archivos-carpeta-ejecutiva.component';
const routes: Routes = [
  { path: '', component: SeleccionModulosComponent },
  { path:'dashboardadmin', loadChildren: () => DashboardadminModule },
  { path: 'inicio-sesion', component: InicioSesionComponent },
  { path: 'registro-usuarios', component: RegistroUsuarioComponent },
  { path: 'terminos-y-condiciones', component: TerminosYCondicionesComponent },
  {
    path: 'seleccion-modulos', component: SeleccionModulosComponent,
    children: [
      { path: 'lista-direcciones', component: ListaDireccionesComponent },
      { path: 'lista-modulos-principales', component: ListaModulosPrincipalesComponent },
      { path: 'generador-carpeta-ejecutiva', component: GeneradorCarpetaComponent },
    ]
  },
  {
    path: 'buscador-archivos-obras', component: BuscadorArchivosObrasComponent
  },
  {
    path: 'tablero-presupuestos', component: TableroPresupuestoComponent,
    children: [
      { path: '', component: HomePresupuestosComponent },
    ]
  },
  {
    path: 'tablero', component: TableroComponent,
    children: [
      { path: 'carga-presupuestos', component: CargaPresupuestosComponent },
      { path: 'seleccion-reportes', component: SeleccionReportesComponent },
      { path: 'generador-carpeta-ejecutiva', component: GeneradorCarpetaComponent },
      { path: 'busqueda-proceso', component: BusquedaObrasProcesoComponent },
      { path: 'busqueda-planeacion', component: BusquedaObrasPlaneacionComponent },
      { path: 'admon-usuarios', component: AdministrarUsuariosComponent },
      { path: 'admon-catalogos', component: AdministrarCatalogosComponent },
      { path: 'admon-perfiles', component: AdministrarPerfilesComponent },
      { path: 'generacion-obras', component: GeneracionObrasComponent },
      { path: 'consultar-obras', component: ConsultarObrasComponent },
      { path: 'consultar-historico-obras', component: ConsultarHistoricoObrasComponent },
      { path: 'edicion-ficha/:keyObra', component: EdicionFichaTecnicaComponent },
      { path: 'edicion-ficha-planeacion/:keyObra', component: EdicionFichaPlaneacionComponent },
      { path: 'busquedas-avanzadas', component: BusquedasAvanzadasComponent },
      { path: 'busqueda-fotos-obra', component: BusquedasFotosObraComponent },
      { path: 'filtro-fotos-capas', component: FiltroFotosCapasComponent },
      { path: 'levantamiento-obra', component: LevantamientoObraComponent },
      { path: 'levantamiento-avance', component: LevantamientoAvanceComponent },
      { path: 'edicion-incidencia-obra/:keyTramoLicitacion/:keyObra', component: EdicionIncidenciaObraComponent },
      { path: 'admon-tramo-licitacion/:keyObra', component: AdmonTramoLicitacionComponent },
      { path: 'generador-incidencia-obra/:keyObra', component: GeneradorIncidenciaObraComponent },
      { path: 'generador-carpeta-ejecutiva/:bandera', component: GeneradorCarpetaComponent },
      { path: 'aprobacion-levantamiento-obra', component: AprobacionLevatamientoObrasComponent },
      { path: "archivos-carpeta-ejecutiva", component: ArchivosCarpetaEjecutivaComponent },
      { path: 'ver-larguillo/:keyLevantamientoObra', component: LarguilloComponent },
      { path: 'detalle-obra', component: DetalleObraComponent }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
